import { Pipe, PipeTransform } from '@angular/core';
import { IChallengeTypeInfo } from 'app/core/services/mainapp/multiplePathways';

@Pipe({ name: 'selectedChallenges' })

export class SelectedChallengesPipe implements PipeTransform {
    transform(list: IChallengeTypeInfo[], selected: number[]) {
        if (!list || !list.length || !selected || !selected.length) return 0;

        return list.map(l => {
            return l.Challenges.filter(c => selected.filter(s => s === c.ChallengeID).length)
                .map(c => {
                    return {
                        ChallengeType: l.Description,
                        ChallengeID: c.ChallengeID,
                        Description: c.Description
                    };
                });
        }).reduce((prev, cur) => prev.concat(cur), []);
    }
}

